import { render, staticRenderFns } from "./contractorsEdit.vue?vue&type=template&id=1befc4c8&scoped=true&"
import script from "./contractorsEdit.vue?vue&type=script&lang=js&"
export * from "./contractorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1befc4c8",
  null
  
)

export default component.exports